module.exports = __webpack_public_path__ + "img/VetoSansCond-MediumItalic_1.16adec2e.svg";